const LOAD_TIMEOUT_MS = 15000;
class MeshLoadingTracker {
    constructor() {
        this.nextLoadId = 0;
        this.pendingLoads = new Map();
    }
    beginLoad(meshName, pieceName, trackLoad = true) {
        if (!trackLoad) {
            return undefined;
        }
        const loadId = this.nextLoadId++;
        const timeoutHandle = window.setTimeout(() => {
            const pendingLoad = this.pendingLoads.get(loadId);
            if (pendingLoad === undefined)
                return;
            this.pendingLoads.delete(loadId);
            console.warn(`[rendering] Mesh load timed out, forcing shadow update release: ${this.getLoadName(pendingLoad)}`);
        }, LOAD_TIMEOUT_MS);
        this.pendingLoads.set(loadId, {
            meshName,
            pieceName,
            timeoutHandle
        });
        return loadId;
    }
    endLoad(loadId) {
        if (loadId === undefined)
            return;
        const pendingLoad = this.pendingLoads.get(loadId);
        if (pendingLoad === undefined)
            return;
        window.clearTimeout(pendingLoad.timeoutHandle);
        this.pendingLoads.delete(loadId);
    }
    hasPendingLoads() {
        return this.pendingLoads.size > 0;
    }
    getPendingLoads() {
        return this.pendingLoads.size;
    }
    getLoadName(load) {
        if (load.pieceName === undefined) {
            return load.meshName;
        }
        return `${load.meshName}#${load.pieceName}`;
    }
}
export const meshLoadingTracker = new MeshLoadingTracker();
